import useCancerConfig from '@oncolens/oncolens-ui/lib/hooks/config/useCancerConfig';
import { FormStoreProps } from '@oncolens/oncolens-ui/lib/libraries/FormStore';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useParams } from 'react-router';
import { GuidelineTemplateConditionDto, useGuidelineTemplateById } from '../api/guideline-template';

export interface GuidelineTemplateFormValues {
  name: string;
  diseaseConditions: GuidelineTemplateConditionDto[];
}
function useHydrateGuidelineTemplate(
  updateStore: (fn: (state: FormStoreProps<GuidelineTemplateFormValues>) => void) => void,
) {
  const { templateId } = useParams();
  const { data: cancerConfigs } = useCancerConfig();
  useGuidelineTemplateById(templateId || '', {
    enabled: !!templateId,
    onSuccess: (data) => {
      updateStore((x) => {
        Object.assign(x, {
          ...data,
          diseaseConditions: data.diseaseConditions.sort(
            (a, b) => (a.sortOrder || 0) - (b.sortOrder || 0),
          ),
        });
      });
    },
  });
  return { templateId, cancerConfigs };
}

export { useHydrateGuidelineTemplate };
